var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrialNoticeDialog',{attrs:{"visible":_vm.visible,"mode":"expire","config":_vm.trialConfig,"remain-days":_vm.remainDays},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }